/* istanbul ignore file */
import React, { Component, createRef } from 'react'
import PropTypes from 'prop-types'
import GoogleMap from 'google-map-react'
import classnames from 'classnames/bind'
import NotAvailable from '../notAvailable'
import styles from './index.scss'

const cx = classnames.bind(styles)

const Marker = () => (
  <div
    style={{
      marginLeft: -10,
      marginTop: -10,
      backgroundColor: 'red',
      width: 20,
      height: 20,
      borderRadius: 20,
    }}
  />
)

class Map extends Component {
  static propTypes = {
    apiKey: PropTypes.string,
    apiChannel: PropTypes.string,
    lat: PropTypes.number.isRequired,
    lng: PropTypes.number.isRequired,
    zoom: PropTypes.number,
    streetview: PropTypes.bool,
    children: PropTypes.element,
    elmId: PropTypes.string,
    className: PropTypes.string,
  }

  static defaultProps = {
    streetview: false,
    zoom: 18,
  }

  constructor() {
    super()
    this.myRef = createRef()
    this.state = {
      streetViewAvailable: true,
    }
  }

  // Implementation details as per
  // https://github.com/istarkov/google-map-react/issues/251
  // https://developers.google.com/maps/documentation/javascript/examples/streetview-service
  switchMode = ({ map, maps }) => {
    const { lat, lng, streetview } = this.props
    if (!streetview) return

    const sv = new maps.StreetViewService()

    // const [lat, lng] = [33.9031881, -117.8098913]

    sv.getPanorama(
      {
        location: { lat, lng },
        radius: 50,
      },
      (data, status) => {
        if (status === maps.StreetViewStatus.OK) {
          const panorama = new maps.StreetViewPanorama(this.myRef.current, {
            position: { lat, lng },
            pov: {
              heading: 270,
              pitch: 0,
            },
            visible: true,
          })
          panorama.setPano(data.location.pano)
          panorama.setPov({
            heading: 270,
            pitch: 0,
          })
          panorama.setVisible(true)
        } else {
          this.setState({ streetViewAvailable: false })
        }
      }
    )
  }

  render() {
    const {
      children,
      apiKey,
      apiChannel,
      lat,
      lng,
      zoom,
      className,
      elmId,
      streetview,
    } = this.props

    if (streetview && !this.state.streetViewAvailable) {
      return <NotAvailable text='Street View Not Available' />
    }

    /**
     * We need to compute the children at this point, because the google-map component does
     * not skip over any *null* children
     */
    const passedChildren = children || <Marker {...{ lat, lng }} />

    return (
      <div className={className} data-elm-id={elmId}>
        <GoogleMap
          yesIWantToUseGoogleMapApiInternals
          className={cx('maps')}
          center={{
            lat,
            lng,
          }}
          defaultZoom={zoom}
          bootstrapURLKeys={{
            client: apiKey,
            channel: apiChannel,
            v: 3,
          }}
          options={{
            streetViewControl: true,
            zoomControl: true,
            zoomControlOptions: { position: 6 },
            draggable: true,
            overviewMapControl: true,
            rotateControl: true,
            mapTypeControl: true,
          }}
          onGoogleApiLoaded={this.switchMode}
        >
          {passedChildren}
        </GoogleMap>
        {streetview && (
          <div
            ref={this.myRef}
            style={{
              position: 'absolute',
              top: 0,
              height: '100%',
              width: '100%',
            }}
          />
        )}
      </div>
    )
  }
}

export default Map
